// What the Paddle checkout carries for the backend: who this visitor is in PostHog and the landing that brought them.
// The transaction webhook keeps custom data, and signup aliases the funnel visitor to the new account from it.
// The Meta pixel writes _fbp after a first visit's touch is built, so a missing fbp or fbc comes from the current cookies.
import { getPostHogIdentity } from "../tracking/tracking-service"
import { checkoutTouchJson, readFirstTouch, type LandingTouch } from "./landing-touch"
import { getFacebookCookies } from "./meta-ads-utils"

const withCurrentFacebookCookies = (touch: LandingTouch): LandingTouch => {
  const cookies = getFacebookCookies()
  return { ...touch, fbp: touch.fbp || cookies.fbp || undefined, fbc: touch.fbc || cookies.fbc || undefined }
}

export const buildCheckoutCustomData = (): Record<string, string> => {
  const { distinctId, sessionId } = getPostHogIdentity()
  const touch = readFirstTouch()
  return {
    pt_posthog_distinct_id: distinctId ?? "",
    pt_posthog_session_id: sessionId ?? "",
    ...(touch
      ? { pt_touch: checkoutTouchJson({ ...withCurrentFacebookCookies(touch), user_agent: navigator.userAgent }) }
      : {}),
  }
}
